/**
 * Created by johnathansaunders on 12/9/17.
 */
import React from 'react';
import RaisedButton from 'material-ui/RaisedButton';

const MyAwesomeReactComponent = () => (
    <RaisedButton label="Default" />
);

export default MyAwesomeReactComponent;


// WEBPACK FOOTER //
// ./src/MyAwesomeReactComponent.js